let serialNumType = [
  'RANDOM',
  'DB_SEQ'
]

export default serialNumType
